import { render, staticRenderFns } from "./device-stats.vue?vue&type=template&id=1b16e1ef&"
import script from "./device-stats.vue?vue&type=script&lang=js&"
export * from "./device-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports